import React from 'react';
import styles from './styles.css';

export default function OthersSummary({ text, items }) {
	const tooltipContent = items.join(', ');

	return (
		<span className={styles.othersSummary} data-tooltip-id="others-tooltip" data-tooltip-content={tooltipContent}>
			{text}
		</span>
	);
}
